<app-container>
  <ng-container *ngTemplateOutlet="content" />
</app-container>

<ng-template #content>
  <main
    class="flex xl:flex-row flex-col w-full gap-6 xl:py-[3.75rem] p-4 xl:p-0"
  >
    <ng-container *ngTemplateOutlet="side" />
    @if (center(); as center) {
      <section class="w-full h-full">
        <router-outlet />
      </section>
    }
  </main>
</ng-template>

<ng-template #side>
  <section class="flex flex-col w-full xl:max-w-[18.125rem]">
    <div class="flex flex-col items-start self-start flex-1 w-full gap-3">
      <div
        class="w-full border border-gray-100 rounded-[20px] flex items-center flex-col overflow-hidden"
      >
        @if (center(); as center) {
          <div
            class="p-5 xl:py-10 flex flex-col gap-3 xl:items-center xl:justify-center w-full"
          >
            <div class="flex xl:flex-col gap-3 items-center">
              <app-center-icon size="lg" [color]="centerUser()?.color!" />
              @if (!center.private) {
                <p class="text-xl font-semibold text-gray-800">
                  {{ center.name }}
                </p>
              }
            </div>
            <div
              class="flex w-full xl:flex-col xl:justify-center xl:items-center xl:gap-3 justify-between"
            >
              <div class="flex flex-col items-center gap-2">
                <div class="flex items-center gap-2">
                  <p class="text-gray-800 font-medium">{{ user()?.name }}</p>
                  <app-center-role-badge />
                </div>
              </div>
              <button
                (click)="handleExitCenter()"
                class="flex gap-2 items-center"
              >
                <app-icon
                  name="solar:logout-2-bold-duotone"
                  class="!size-5 text-gray-500"
                />
                <p class="text-gray-500 text-sm">센터 나가기</p>
              </button>
            </div>
          </div>

          <div class="flex divide-x w-full">
            <button
              [cdkMenuTriggerFor]="colorPicker"
              class="flex gap-2 items-center justify-center transition-all w-full p-3 bg-gray-50 hover:bg-gray-100 active:bg-gray-200"
            >
              <div
                [style]="{
                  'background-color': centerUser()?.color || '#1693C9',
                }"
                class="size-4 rounded-full"
              ></div>
              <p class="text-gray-500 text-sm font-medium">대표 색상 변경</p>
            </button>
            <button
              routerLink="/my-page/info"
              class="flex gap-2 items-center justify-center transition-all w-full p-3 bg-gray-50 hover:bg-gray-100 active:bg-gray-200"
            >
              <app-icon
                name="material-symbols:edit"
                class="size-4 text-gray-500"
              />
              <p class="text-gray-500 text-sm font-medium">내 정보 수정</p>
            </button>
          </div>
        }
      </div>

      <div class="xl:flex hidden w-full flex-col gap-0.5">
        @for (option of options(); track $index) {
          @let routerLink = option.lock ? null : '/center/' + option.value;

          <button
            (click)="handleMenuClick(option, $event)"
            [ngClass]="
              option.lock
                ? 'cursor-default text-gray-500'
                : 'transition-colors hover:bg-gray-50 text-gray-800'
            "
            class="flex gap-2 items-center w-full p-5 rounded-xl"
            [routerLinkActive]="['bg-primary-50', 'hover:bg-primary-50']"
            [routerLink]="routerLink"
          >
            <p class="font-medium">{{ option.label }}</p>
            @if (option.lock) {
              <app-icon name="mdi:lock" class="text-primary" size="xs" />
            }
          </button>
        }
      </div>
      <div class="relative flex overflow-x-auto w-full">
        <app-tabs
          scrollEnabled
          class="xl:hidden"
          [options]="segmentOptions()"
          [(value)]="segment"
          (valueChange)="onSegmentChange($event)"
        />
      </div>
    </div>
  </section>
</ng-template>

<!-- 색상 변경 -->
<ng-template #colorPicker>
  <app-color-picker (setColor)="setColor($event)" />
</ng-template>
